import { render } from "./Session.vue?vue&type=template&id=065d84e9&scoped=true"
import script from "./Session.vue?vue&type=script&lang=js"
export * from "./Session.vue?vue&type=script&lang=js"

import "./Session.vue?vue&type=style&index=0&id=065d84e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065d84e9"]])

export default __exports__